import React, { Component } from "react";
import { queryGetEmailCampaignAudience } from 'Apollo'
import { graphql, compose } from "react-apollo";
import Picker from "module-common/Picker";

class AudienceLabel extends Component {
    render() {
        const { contactInformation, campaignDefaults, summary} = this.props
        return <span>
            {contactInformation.companyName} ({summary.memberCount})
        </span>
    }
}

export default graphql(queryGetEmailCampaignAudience, {
    name: 'audience'
})(
    class Selection extends Component {

        state = {
            selected: null
        }

        render() {
            const { selected } = this.state
            const { onChange, audience: { loading, getAudienceList } } = this.props
            const options = getAudienceList ? getAudienceList.map(item => {
                return {
                    label: <AudienceLabel {...item} />,
                    value: item.id,
                    audience: item
                }
            }) : []
            return <Picker 
                options={options}
                onSelected={({ audience }) => { 
                    this.setState({...this.state, selected: audience })
                    onChange && onChange(audience)
                }}
            >
                <span>
                    {selected && <AudienceLabel {...selected} />}
                    {!selected && "Select the campaign's audience"}
                </span>
            </Picker>    
        }
    }
)


// WEBPACK FOOTER //
// ./src/module-email-campaign/campaign/AudienceSelectionWithQuery.js